module.exports = __webpack_public_path__ + "img/CB3-Off-1.bf65fa10.gif";